// extracted by mini-css-extract-plugin
module.exports = {"box":"TextStackButton--box--hgk-I","max_width":"TextStackButton--max_width--2MSwx"};